import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import TtyOutlinedIcon from '@mui/icons-material/TtyOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

interface ProfileDropdownProps {
  onMyProfileClick: () => void;
  onFavouritesClick: () => void;
  onOrdersClick: () => void;
  onContactUsClick: () => void;
  onSignOutClick: () => void;
}

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  onMyProfileClick,
  onFavouritesClick,
  onOrdersClick,
  onContactUsClick,
  onSignOutClick
}) => {
  return (
    <div className="navbar-user-list-wrapper">
      <div className="navbar-user-list-item" onClick={onMyProfileClick}>
        <AccountCircleOutlinedIcon />
        <span>My Profile</span>
      </div>
      <hr />
      <div className="navbar-user-list-item" onClick={onFavouritesClick}>
        <FavoriteBorderOutlinedIcon />
        <span>Wish List</span>
      </div>
      <hr />
      <div className="navbar-user-list-item" onClick={onOrdersClick}>
        <ShoppingCartOutlinedIcon />
        <span>My Orders</span>
      </div>
      <hr />
      <div className="navbar-user-list-item" onClick={onContactUsClick}>
        <TtyOutlinedIcon />
        <span>Contact Us</span>
      </div>
      <hr />
      <div className="navbar-user-list-item logout" onClick={onSignOutClick}>
        <LogoutOutlinedIcon />
        <span>Sign Out</span>
      </div>
    </div>
  );
};

export default ProfileDropdown;
